import { z } from 'zod';
/** Состояние одной зависимости, проверяемой health-эндпоинтом. */
export const dependencyStatusSchema = z.object({
    status: z.enum(['up', 'down']),
    /** Длительность проверки, мс. */
    latencyMs: z.number().nonnegative(),
    /** Текст ошибки, если status = down. Секреты сюда не попадают. */
    error: z.string().optional(),
});
export const healthResponseSchema = z.object({
    /**
     * ok — база и Redis живы; degraded — нет хотя бы одной из них.
     *
     * Медиасервер в приговор не входит: этот эндпоинт служит healthcheck'ом
     * контейнера `api`, и 503 из-за упавшего go2rtc перезапускал бы работающий
     * `api` вместе с картой, мониторингом и открытыми VNC-сессиями.
     */
    status: z.enum(['ok', 'degraded']),
    version: z.string(),
    /** Аптайм процесса api, секунды. */
    uptimeSec: z.number().nonnegative(),
    timestamp: z.iso.datetime(),
    dependencies: z.object({
        database: dependencyStatusSchema,
        redis: dependencyStatusSchema,
        /**
         * Медиа-ядро go2rtc. Необязательно: старый клиент, читающий ответ
         * свежего сервера, не должен спотыкаться о новое поле, а тесты, где
         * медиасервера нет, — переписываться целиком.
         */
        go2rtc: dependencyStatusSchema.optional(),
    }),
});
//# sourceMappingURL=health.js.map